<template>
  <div v-if="cIcon" :class="['c-tag', variant, { xs: size === 'xs', sm: size === 'sm', lg: size === 'lg' }]">
    <UiIcon v-if="cIcon !== 'game'" :icon="cIcon" :size="iconSize" />
    <img v-else src="/img/game/bolt.svg?url" :height="iconSize" :width="iconSize" />
    <div v-if="hasLabel" class="lb" :class="{ 'no-shrink': noShrink }">
      <div><slot>{{ label }}</slot></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, useSlots } from 'vue'
import { getObjectIcon } from '@/common/util'

import UiIcon from '@/components/ui/icon.vue'

const slots = useSlots()

const { type = '', label = '', iconSize = '16px', noShrink = false, icon = '', size = 'md' } = defineProps<{
  type?: string,
  label?: string
  noShrink?: boolean
  icon?: string
  iconSize?: number | string
  size?: 'xs' | 'sm' | 'md' | 'lg'
}>()

const hasLabel = computed(() => {
  return !!label || !!slots.default
})

// Tipo normalizado
const cIcon = computed(() => {
  if (icon) return icon

  return getObjectIcon(type)
})

const variant = computed(() => {
  switch (type?.toLowerCase()) {
    case 'required':
    case 'expired':
      return 'danger'
    case 'new':
      return 'new'
    case 'neutral':
      return 'gray'
    case 'availableat':
      return 'warning'
    case 'requisites':
      return 'warning'
    // Relacionados ao tipo
    case 'top10':
      return '!bg-yellow-200 text-yellow-900 dark:text-yellow-800'
    // Pontuação já conquistada pelo usuário
    case 'gameearned':
      return 'success'
    default:
    case 'game':
      return 'content'
  }
})
</script>

<style scoped lang="scss">
.c-tag {
  background-color: var(--c-primary-200);
  color: var(--c-primary-800);
  font-size: .875rem;
  font-weight: 500;
  padding: .5rem;
  border-radius: .375rem;
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;

  &.xs {
    padding: .125rem;
    font-size: .75rem;
    border-radius: .25rem;
  }

  &.sm {
    padding: .25rem;
  }

  &.lg {
    padding: .75rem;
  }

  &.gray {
    background-color: #EFEFEF;
    color: #494749;
  }

  &.new {
    background-color: #CFE7F7;
    color: #094A77;
  }

  &.danger {
    background-color: #F6D0DE;
    color: #8F0E3C;
  }

  &.content {
    background-color: #E4D9F2;
    color: #512C80;
  }

  &.warning {
    background-color: #FFF8DB;
    color: #ac8227;
  }

  &.success {
    background-color: #D2EFDC;
    color: #0F5132;
  }

  .lb {
    box-sizing: border-box;
    display: block;
    max-width: 0;
    overflow: hidden;
    white-space: nowrap;
    transition: max-width 0.6s ease-in-out;
    > div { margin-left: .5rem; }
  }

  &.xs .lb > div {
    margin-left: .25rem;
  }

  &:hover .lb, .lb.no-shrink {
    max-width: 300px;
  }
}
</style>
